import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isArray } from "lodash";

// Returns the current active work order object.
// Prefers detailed state at tasks.workorderData.workorderData; falls back to tasks list lookup. List fallback requires passed workOrderNumber.
export const useCurrentWorkOrder = (workOrderNumber) => {
    const detailedWO = useSelector((state) => state.tasks?.workorderData?.workorderData);
    const tasks = useSelector((state) => state.tasks?.tasks);

    const currentWorkOrder = useMemo(() => {
        const hasDetails = detailedWO && Object.keys(detailedWO).length > 0;
        if (hasDetails) return detailedWO;
        if (!workOrderNumber) return null;
        if (!isArray(tasks)) return null;
        return tasks.find((t) => t?.workOrderNumber === workOrderNumber) || null;
    }, [detailedWO, tasks, workOrderNumber]);

    return currentWorkOrder;
};

export default useCurrentWorkOrder;
